/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpenTaskItem } from '../../models/open-task-item';

export interface GetOpenTasks$Params {
  workCenterId: number;
  shiftId: number;
}

export function getOpenTasks(http: HttpClient, rootUrl: string, params: GetOpenTasks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OpenTaskItem>>> {
  const rb = new RequestBuilder(rootUrl, getOpenTasks.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('shiftId', params.shiftId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OpenTaskItem>>;
    })
  );
}

getOpenTasks.PATH = '/api/v1/ShiftReport/{workCenterId}/OpenTasks/{shiftId}';
